import React, {useState} from 'react';
import './FAQ.scss';

const FAQ = ({items = [], title = 'שאלות נפוצות', className = ''}) => {
  const [expandedItems, setExpandedItems] = useState(new Set());

  const toggleItem = (index) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(index)) {
      newExpanded.delete(index);
    } else {
      newExpanded.add(index);
    }
    setExpandedItems(newExpanded);
  };

  const isExpanded = (index) => expandedItems.has(index);

  return (
    <div className={`faq-container ${className}`}>
      {title && <h2 className='faq-title'>{title}</h2>}

      <div className='faq-list'>
        {items.map((item, index) => (
          <div key={index} className={`faq-item ${isExpanded(index) ? 'expanded' : ''}`}>
            <button className='faq-question' onClick={() => toggleItem(index)} aria-expanded={isExpanded(index)}>
              <span className='question-text'>{item.question}</span>
              <span className='expand-icon'>
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' className={isExpanded(index) ? 'rotated' : ''}>
                  <path d='M6 9L12 15L18 9' stroke='var(--theme-primary, #810EA9)' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
              </span>
            </button>

            <div className='faq-answer'>
              <div className='answer-content'>{typeof item.answer === 'string' ? <span>{item.answer}</span> : item.answer}</div>
            </div>
            {index < items.length - 1 && <div className='faq-list-divider' />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
